import { Link } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import React from "react"
import Animated from "../components/animated"
import AnimatedResidences from "../components/animatedResidences"
import AnimatedStays from "../components/animatedStay"

const HeroBanner = ({ image, logo, video, title, home, subtitle, stays, residences, fixedTitle, secondTitle, alt = false, link, buttonText, scroll = false }) => {
  return (
    <div className='hero--banner h-100vh bg-grey ml60 pos-rel flex m-m0'>
      {title && (
        <h1 className='hero--title h1 m0 white'>
          <p className='m0'>{title}</p>
          {subtitle && <p className='hero--subtitle h5 xxs white mt20 text-center'>{subtitle}</p>}
        </h1>
      )}
      {home ? <Animated /> : ""}
      {stays ? <AnimatedStays /> : ""}
      {residences ? <AnimatedResidences /> : ""}
      {fixedTitle ? <FixedTitle link={link} isAlt={alt} title={fixedTitle} secondTitle={secondTitle} buttonText={buttonText} scroll={scroll} /> : ""}
      <GatsbyImage image={image?.gatsbyImageData} alt='Hero Image' className='bg-image' />
      {video && (
        <video id='video' loop={true} playsInline={true} muted={true} autoPlay={true} className='bg-image cover' allowFullScreen>
          <source src={video} />
        </video>
      )}
    </div>
  )
}

export default HeroBanner

const FixedTitle = ({ title, secondTitle, isAlt = false, link, buttonText, scroll = false }) => {
  const scrollDown = () => {
    const height = document.getElementById("contact")?.offsetTop
    window.scrollTo({ top: height, left: 0, behavior: "smooth" })
  }

  const As = isAlt ? "a" : Link

  return (
    <div className='fixed--header active small m-show text-center w-100vw flex flex-col'>
      <div>
        {scroll ? (
          <p onClick={scrollDown} role='presentation' className='button inverse wide h-white link white'>
            Register Interest
          </p>
        ) : (
          <As target='_blank' rel='noreferrer' className={`button ${isAlt ? "white-btn" : "h-white white"} inverse mb20 max-200 ma link`} to={link} href={link}>
            {buttonText}
          </As>
        )}
      </div>
      <div className='p20'>
        {title}{" "}
        {secondTitle && (
          <span className='ml5 pl20 with-dot'>
            <span className='op-50 m-op-100'>{secondTitle}</span>
          </span>
        )}
      </div>
    </div>
  )
}
